import React from 'react';

/**
 * Search input with an optional clear (×) button when there is text.
 */
export default function SearchInput({
    value,
    onChange,
    onClear,
    placeholder,
    inputRef,
    className = 'gs-input',
    'aria-label': ariaLabel,
}) {
    const hasValue = Boolean(value && String(value).length > 0);

    const handleClear = () => {
        if (onClear) {
            onClear();
        } else if (onChange) {
            onChange({ target: { value: '' } });
        }
        // Keep focus in the field after clearing
        if (inputRef?.current) {
            inputRef.current.focus();
        }
    };

    return (
        <div className={`gs-search${hasValue ? ' has-value' : ''}`}>
            <input
                ref={inputRef}
                className={className}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                aria-label={ariaLabel || placeholder}
            />
            {hasValue && (
                <button
                    type="button"
                    className="gs-search__clear"
                    onClick={handleClear}
                    aria-label="Clear search"
                    title="Clear search"
                >
                    ×
                </button>
            )}
        </div>
    );
}
